import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import {WorkLogWeekly, BatchWorkLogWeekly} from "../models/WorkLogWeekly";
import environment from "../environment.json";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import BatchProcessorResponse from "../models/BatchProcessorResponse";

class WorkLogWeeklyService extends GenericCrudServiceV2<WorkLogWeekly> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  approveWeek(instance: WorkLogWeekly): Promise<ApiResponseV2<WorkLogWeekly>> {
    return this.create(instance);
  }

  batchApproveWeeks(instance: BatchWorkLogWeekly): Promise<ApiResponseV2<BatchProcessorResponse>> {
    return HttpClientV2.post(`${environment.baseURL}${this.basePath}/batch`, instance);
  }
}

export default new WorkLogWeeklyService("/ensolvers-ops/work-log-weekly");
